import { useQuery } from '@tanstack/react-query';
import { GetEntityTotalsResponse } from '@hud/portal-dtos/webapp-overview.dto';
import { useClient } from '../useClient';
import { PORTAL_BASE } from '../../consts';
import { TimeFrame } from '@hud/portal-dtos/webapp-common.dto';

export const QUERY_KEY = 'OverviewEntityTotals';

type OverviewEntityTotalsParams = {
  environmentName: string;
  timeFrame: TimeFrame;
  serviceIds?: number[];
};

export default function useOverviewEntityTotals(
  overviewEntityTotalsParams: OverviewEntityTotalsParams,
) {
  const { client, isReady } = useClient();
  const { environmentName, timeFrame, serviceIds } = overviewEntityTotalsParams;
  const params = {
    environmentName,
    timeFrame,
    serviceIds,
  };

  return useQuery({
    queryKey: [QUERY_KEY, environmentName, timeFrame, serviceIds],
    queryFn: async () => {
      const response = await client.get<GetEntityTotalsResponse>(
        `${PORTAL_BASE}/overview/entity-totals`,
        { params },
      );
      return GetEntityTotalsResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
